export default __webpack_public_path__ + "static/media/place-holder-request.f6e985f0.svg";